export default class ResetPwRequest {

	public readonly username: string;

	public constructor(username: string) {
		this.username = username;
	}

}
